import { Dispatch } from "redux";
import {PaymantPawapayActionTypes, PaymantPawapayAction} from "../../types/Payments/paymentPawapayTypes";
import axios from "axios";

interface ErrorResponse {
    code: number;
    message: string;
}

export const getPawapayPaymentInfo = (ticketCode: string): any => {
    return async (dispatch: Dispatch<PaymantPawapayAction>) => {
        try {
            dispatch({ type: PaymantPawapayActionTypes.FETCH_PAWAPAY_PAYMENT_DATA });
            const response = await axios({
                method: 'get',
                url: `/api/claim/${ticketCode}`,
                withCredentials: false
            });
            if (response.data) {
                dispatch({ type: PaymantPawapayActionTypes.FETCH_PAWAPAY_PAYMENT_DATA_SUCCESS, payload: response.data });
            } else {
                dispatch({ type: PaymantPawapayActionTypes.FETCH_PAWAPAY_PAYMENT_DATA_ERROR, payload: response.status });
            }
        } catch (error: any) {
            let errorPayload: ErrorResponse;
            if (error.response && error.response.data) {
                if (typeof error.response.data === 'string') {
                    errorPayload = {
                      code: error.response.status,
                      message: error.response.data,
                  }
                } else {
                    errorPayload = {
                        code: error.response.status,
                        message: `Operator Error: ${error.response.data.detail}`
                    }
                }
            } else {
                errorPayload = { code: -1, message: 'Unknown error occurred' };
            }
            console.log(errorPayload);
        }
    }
}
